import Filter from '../Filter';
import Sort from '../Sort';
import {getPaginatedPostalCodes} from '../../api/admin/PostalCodeApi';

export default class PostalCodeFilter extends Filter {
  constructor(data) {
    super(data);

    this.postalCode = data?.postalCode;
    this.prefecture = data?.prefecture;
    this.city = data?.city;

    this.sorts = {
      postalCode: data?.sorts?.postalCode ?? new Sort(),
      prefecture: data?.sorts?.prefecture ?? new Sort(),
      city: data?.sorts?.city ?? new Sort(),
    }
  }

  get key() {
    return 'postal-codes';
  }

  get paginatedFetcher() {
    return async () => await getPaginatedPostalCodes(this);
  }
}
